import { useAuth0 } from "@auth0/auth0-react"
import { toast } from "bulma-toast"

export const useAuth0Authentication = () => {

    const { getAccessTokenSilently, loginWithPopup, loginWithRedirect } = useAuth0()
    
    const isInIframe = (): boolean => {
        try {
            return window.self !== window.top
        } catch (e) {
            return true
        }
    }

    const handleLogin = async () => {
        if (isInIframe()) {
            await loginWithPopup()
        } else {
            await loginWithRedirect()
        }
    }

    const getAuth0AccessToken = async (): Promise<string | undefined> => {
        try {
            return await getAccessTokenSilently()
        } catch (e) {
            // Handle re-auth required errors
            if (e.error === 'login_required' || e.error === 'consent_required') {
                try {
                    if (isInIframe()) {
                        await loginWithPopup()
                    } else {
                        await loginWithRedirect()
                    }
                    // Retry after successful re-auth
                    return await getAccessTokenSilently()
                } catch (reAuthError) {
                    if (reAuthError.name === 'PopupBlockedError') {
                        // Popup was blocked — notify user
                        console.error('Popup blocked — please allow popups for this site')
                        toast({
                            message: 'Please allow popups to re-authenticate',
                            type: 'is-warning',
                            position: 'bottom-right',
                        })
                    } else {
                        // Re-auth itself failed
                        console.error('Re-authentication failed', reAuthError)
                    }
                }
            } else {
                // Unexpected error — surface it rather than swallowing
                console.error('Unexpected token error', e)
                throw e
            }
        }
    }

    return { handleLogin, getAuth0AccessToken }
}